import React from "react";

import { Button, TextAreaField } from "../../../../helpers";

import CartItems from "./CartItems";
import ShippingAddressCards from "../../../../common/ShippingAddressCards";


const Checkout = (props) => {
    const { 
        setVisibleCheckout, 
        cartItems,
        products,
        updateCartItems,
        handleSubmit,
        remarks,
        setRemarks,
        shippingAddresses,
        selectedShipAddrId,
        setSelectedShipAddrId
    } = props

    const handleShippingAddress = (addrId) => {
        setSelectedShipAddrId(addrId)
    }

    return(
        <div className="flex flex-column justify-content-between custom-scrollbar">
            <div className="ustom-scrollbar-inner">
                <CartItems 
                    cartItems={cartItems}
                    products={products}
                    updateCartItems={updateCartItems}
                />
                <p className="mt-3 text-base font-semibold">Shipping Address</p>
                <ShippingAddressCards shippingAddresses={shippingAddresses} selectedAddressId={selectedShipAddrId} handleShippingAddress={handleShippingAddress} />
                <div className="grid">
                    <div className="flex flex-column col-12 mb-2 lg:col-8 lg:mb-0">
                        <TextAreaField name="remarks" labelText="Remarks" value={remarks} onChange={e => setRemarks(e.target.value)}/>
                    </div>
                </div>
                <div className="flex justify-content-end">
                    <Button className="" label="SUBMIT" outlined onClick={() => handleSubmit(remarks)} />
                    <Button className="ml-2" label="CANCEL" outlined severity="danger" onClick={() => setVisibleCheckout(false)} />
                </div>
            </div>
        </div>
    )
}

export default Checkout;